import { defineComponent as E, useAttrs as M, useSlots as k, useCssModule as H, ref as x, computed as w, watch as A, onMounted as I, nextTick as P, onBeforeUnmount as V, createBlock as $, openBlock as q, mergeProps as y, unref as p, createSlots as D, withCtx as b, createElementVNode as j, renderSlot as F } from "vue";
import { _ as L } from "./Field.vue_vue_type_script_setup_true_lang-DRaKs9Lm.js";
import { _ as N } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const U = ["id", "maxlength", "value", "placeholder", "disabled", "readonly", "rows"], W = /* @__PURE__ */ E({
  name: "ll-textarea",
  __name: "Textarea",
  props: {
    modelValue: { default: "" },
    value: { default: null },
    resize: { type: [Boolean, Object], default: !1 },
    placeholder: { default: void 0 },
    rows: { default: void 0 },
    maxlength: { default: void 0 },
    addBottomSpace: { type: Boolean },
    errorText: {},
    hintText: {},
    id: {},
    errorId: {},
    isReadOnly: { type: Boolean },
    isRequired: { type: Boolean },
    label: {},
    showOptionalInLabel: { type: Boolean },
    fieldset: { type: Boolean },
    isDisabled: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:model-value"],
  setup(_, { emit: g }) {
    const c = M(), B = k(), m = H(), t = _, z = g, u = x(), r = x(), R = w(() => t.isReadOnly || "readonly" in c && c.readonly !== !1), T = w(() => {
      const e = { ...c };
      return delete e["data-test"], delete e.class, e;
    });
    A(
      () => t.resize,
      (e) => {
        var o;
        e ? h() : (o = r.value) == null || o.disconnect();
      }
    );
    const O = (e) => {
      z("update:model-value", e.target.value);
    }, h = () => {
      r.value || !u.value || (r.value = new ResizeObserver(([e]) => {
        const { target: o } = e, s = v(u.value) || document.documentElement, { scrollTop: a } = s;
        let n = 0;
        if (s === document.documentElement) {
          const { top: l, height: i } = C(o), { innerHeight: d } = window;
          n = Math.max(l + i - (d + a), 0);
        } else {
          const { top: l, height: i } = o.getBoundingClientRect(), { top: d } = s.getBoundingClientRect(), { offsetHeight: f } = s, S = l - d;
          n = Math.max(S + i - f, 0);
        }
        n && requestAnimationFrame(() => {
          s.scrollTop = a + n;
        });
      }), r.value.observe(u.value));
    }, v = (e) => {
      const o = e.parentElement;
      if (!o)
        return null;
      const { overflowY: s } = getComputedStyle(o);
      return s !== "visible" ? o : o === document.body ? document.documentElement : v(o);
    }, C = (e) => {
      const { offsetWidth: o, offsetHeight: s } = e;
      let a = 0, n = 0;
      const l = function({ offsetLeft: i, offsetTop: d, offsetParent: f }) {
        a += i, n += d, f && l(f);
      };
      return l(e), {
        top: n,
        left: a,
        width: o,
        height: s
      };
    };
    return I(async () => {
      var e;
      if (t.value !== null)
        throw new Error("ll-input: use :model-value or v-model instead of :value.");
      if (c.onInput)
        throw new Error("ll-input: use the @update:model-value event instead of @input");
      (typeof t.resize == "boolean" && t.resize || (e = t.resize) != null && e.forceBrowserScroll) && (await P(), h());
    }), V(() => {
      var e;
      (e = r.value) == null || e.disconnect();
    }), (e, o) => (q(), $(L, y(t, {
      class: ["stash-textarea", [p(m).root]],
      "data-test": "stash-textarea"
    }), D({
      default: b(({ fieldId: s, hasError: a }) => [
        j("textarea", y({
          id: s,
          ref_key: "textareaRef",
          ref: u,
          class: [
            p(m).textarea,
            "tw-border tw-border-ice-500",
            {
              "stash-textarea--error tw-border-red-500 tw-text-red-500": a,
              "tw-text-ice-700 hover:tw-border-ice-500 focus:tw-border-blue-500 active:tw-border-blue-500": !a && !t.disabled,
              "tw-resize-y": t.resize,
              "tw-min-h-[100px]": !t.rows,
              "tw-resize-none": !t.resize
            }
          ],
          maxlength: t.maxlength,
          value: t.modelValue,
          "data-test": "stash-textarea|textarea",
          placeholder: t.placeholder
        }, T.value, {
          disabled: t.disabled,
          readonly: R.value,
          rows: t.rows,
          onInput: O
        }), null, 16, U)
      ]),
      _: 2
    }, [
      p(B).hint ? {
        name: "hint",
        fn: b(() => [
          F(e.$slots, "hint")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class"]));
  }
}), Y = "_root_slydx_2", G = "_textarea_slydx_7", J = {
  root: Y,
  textarea: G
}, K = {
  $style: J
}, ee = /* @__PURE__ */ N(W, [["__cssModules", K]]);
export {
  ee as default
};
//# sourceMappingURL=Textarea.js.map
